export default { 
    'PPTedit.Saved':'Saved：',
    'PPTedit.end':'END',
    'PPTedit.play':'Play',
    'PPTedit.avatar':'Avatar',
    'PPTedit.InputPlaceholder':'Please input the speech content',
    'PPTedit.share': 'Share'
}